import actions from "./actions";

const initialState = {
  detail: {},
  loading: false,
  list: [],
  shorList: [],
  meta: {},
  error: false,
  newFetched: false,
  newFetchedShort: false,
  shortListMeta: {},
};

export default function channelReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
